module.exports = "<a ng-if=!$ctrl.isLoggedIn() ng-click=$ctrl.login() translate>Login</a> <div ng-if=$ctrl.isLoggedIn()> <span class=icon-profile></span> <span>{{$ctrl.getUser().name}}</span> <a ng-click=$ctrl.logout() translate>Logout</a> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/login/partial.html
// module id = 549
// module chunks = 0